"use client";

import { memo, useEffect, useState } from "react";
import axiosInstance from "@/lib/axios";
import CustomImage from "@/components/ui/CustomImage";
import { useAuth } from "@/contexts/AuthContext";
import { resolveImageUrl } from "@/lib/mediaUrl";

let cachedLogoUrl;

const Logo = ({ big, inverted, showMark = true }) => {
	const { logoUrl: ssrLogoUrl = "" } = useAuth();
	const colorClass = inverted ? "text-white" : "text-inherit";
	const [logoUrl, setLogoUrl] = useState(() => {
		if (ssrLogoUrl) return ssrLogoUrl;
		if (cachedLogoUrl !== undefined) return cachedLogoUrl || null;
		return null;
	});

	useEffect(() => {
		if (ssrLogoUrl) {
			cachedLogoUrl = ssrLogoUrl;
			setLogoUrl(ssrLogoUrl);
			return;
		}

		if (cachedLogoUrl !== undefined) {
			setLogoUrl(cachedLogoUrl || null);
			return;
		}

		let active = true;

		axiosInstance
			.get("/settings")
			.then(({ data }) => {
				if (!active) return;
				const raw = data?.data?.appLogoUrl || data?.data?.appLogo || "";
				const url = raw ? resolveImageUrl(raw, "settings") || raw : "";
				cachedLogoUrl = url;
				setLogoUrl(url || null);
			})
			.catch(() => {
				if (!active) return;
				cachedLogoUrl = "";
				setLogoUrl(null);
			});

		return () => {
			active = false;
		};
	}, [ssrLogoUrl]);

	const brandName = process.env.NEXT_PUBLIC_APP_NAME || "प्रजावार्ता";

	return (
		<span
			className={`logo-brand${big ? " logo-brand--big" : ""}${inverted ? " logo-brand--inverted" : ""}`}
			aria-label={brandName}
		>
			{showMark && (
				<span className="logo-brand__mark">
					{logoUrl ? (
						<CustomImage
							src={logoUrl}
							alt={brandName}
							width={big ? 27 : 23}
							height={big ? 27 : 23}
							className="logo-brand__image"
							folder="settings"
							priority
						/>
					) : (
						<span className="logo-brand__fallback" aria-hidden="true">
							प्र
						</span>
					)}
				</span>
			)}
			<span className={`logo-brand__text ${colorClass}`} aria-hidden="true">
				जावार्ता
			</span>
		</span>
	);
};

export default memo(Logo);
